/**
 * The six abilities in the order every character sheet prints them: Strength, Dexterity,
 * Constitution, Intelligence, Wisdom, Charisma.
 *
 * A character's scores are stored as a JSON object, and Postgres's jsonb returns its keys shortest
 * first, then alphabetically, so a sheet listing them as stored read Wisdom, Charisma, Strength,
 * Dexterity, Constitution, Intelligence. The order is a convention, not a rule, so it lives here
 * rather than in the data; a key that is not one of the six is kept, after them.
 */
const ABILITY_ORDER = ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma'];

export function orderedAbilities(stats: Readonly<Record<string, number>>): [string, number][] {
  const rank = (name: string): number => {
    const at = ABILITY_ORDER.indexOf(name);
    return at === -1 ? ABILITY_ORDER.length : at;
  };
  return Object.entries(stats).sort(([a], [b]) => rank(a) - rank(b));
}
